import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MENU_ITEMS } from "../data/site";
import { SpiceLevel, VegBadge } from "./brand/Icons";

export default function MenuTeaser() {
  const featured = MENU_ITEMS.slice(0, 3);

  return (
    <section
      id="menu"
      data-testid="menu-teaser-section"
      className="bg-cream py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7 reveal">
            <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
              The Menu
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-cocoa mt-3 leading-tight">
              Three favourites.{" "}
              <span className="gold-underline">Six on the menu</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 text-cocoa-soft reveal">
            <p>
              A quick taste of what comes out of our handi. Step inside the full
              menu for descriptions, spice levels and pricing.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
          {featured.map((item, idx) => (
            <article
              key={item.id}
              data-testid={`menu-teaser-card-${item.id}`}
              className="reveal group bg-card-warm rounded-2xl border border-cream-deep overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 relative"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="relative overflow-hidden h-56">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 rounded-full bg-[#FAF3E7]/95 backdrop-blur px-3 py-1 shadow">
                  <VegBadge type={item.type} />
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl text-cocoa leading-snug">
                  {item.name}
                </h3>
                <div className="mt-1 text-[11px] uppercase tracking-[0.22em] text-gold font-semibold">
                  {item.tagline}
                </div>
                <div className="mt-5 flex items-center border-t border-cream-deep pt-4">
                  <SpiceLevel level={item.spice} />
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 flex justify-center reveal">
          <Link
            to="/menu"
            data-testid="menu-teaser-view-full-btn"
            className="inline-flex items-center gap-2 rounded-full bg-[#C8A14B] text-[#FAF3E7] hover:bg-[#B89240] hover:-translate-y-0.5 transition-all px-8 py-3.5 font-semibold shadow-md"
          >
            View Full Menu
            <ArrowRight size={18} />
          </Link>
        </div>
      </div>
    </section>
  );
}
